import axiosConfig from "./axiosConfig";

export interface PingLatest {
  checkTimestamp: string;
  esysUuid: string;
  ipAddress: string | null;
  pingsSent: number;
  pingsReceived: number;
  packetLossPct: number;
  latencyMsMin: number | null;
  latencyMsAvg: number | null;
  latencyMsMax: number | null;
  notes: string | null;
  /** Numeric Mobile Country Code reported by Soracom for the SIM's
   * current cell, or null when the SIM was offline / Soracom hasn't
   * populated the cell yet. */
  networkMcc: number | null;
  /** Numeric Mobile Network Code reported by Soracom for the SIM's
   * current cell, or null. */
  networkMnc: number | null;
  /** Friendly operator name resolved from (mcc, mnc) at write time,
   * or null when the SIM had no cell info. Unknown (mcc, mnc) pairs
   * fall back to a generic "MCC=NNN MNC=NN" label rather than null
   * so consumers can still show *something*. */
  networkName: string | null;
}

export interface PingLatestResponse {
  /**
   * Keyed by esys_uuid. A multi-SIM site (e.g. Avonmouth's two
   * SolarEdge banks) returns one entry per esys so the tile can render
   * different states per SIM. An esys with no ping check yet is simply
   * absent from the map.
   */
  latestByEsys: Record<string, PingLatest>;
}

const getSitePingLatest = async (
  authToken: string,
  siteId: string
): Promise<PingLatestResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/health/ping-latest`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default getSitePingLatest;
